<template>
    <div class="survey-spinner" role="status" :class="[size]"></div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        size: { type: String, default: 'md' },
    },
});
</script>
<style lang="scss">
.survey-spinner {
    display: inline-block;
    position: relative;
    border-radius: 50%;
    width: 1.5rem;
    height: 1.5rem;
    animation: spin 1s linear infinite;
    vertical-align: middle;

    &.sm {
        width: 1rem;
        height: 1rem;
    }

    &.lg {
        width: 2rem;
        height: 2rem;
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
